import { Component, ViewChild, inject } from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { UserFeedback } from '@ra-state';
import { CdkScrollable } from '@angular/cdk/scrolling';
import {
  ISelectItem,
  MultilineInputComponent,
  MainButtonComponent,
  OutlinedButtonComponent,
  RaUiSelectModule,
} from '@ra-web-tech-ui-toolkit/components';

@Component({
  selector: 'app-feedback.modal',
  styleUrls: ['./feedback.component.scss'],
  templateUrl: './feedback.component.html',
  imports: [
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    RaUiSelectModule,
    MultilineInputComponent,
    MatDialogActions,
    MainButtonComponent,
    OutlinedButtonComponent,
  ],
})
export class FeedbackComponent {
  private readonly dialogRef = inject<MatDialogRef<FeedbackComponent>>(MatDialogRef);

  feedbackOptions = [
    {
      id: 1,
      type: 'Provide Feedback',
    },
    {
      id: 2,
      type: 'Enhancement Request',
    },
    {
      id: 3,
      type: 'Report an Issue',
    },
  ];

  feedbackTypeOptions: ISelectItem<string>[] = this.feedbackOptions.map((feedbackOption) => ({
    label: feedbackOption.type,
    value: feedbackOption.type,
  }));

  @ViewChild('feedbackForm') feedbackForm: NgForm;

  cancel(): void {
    this.close(null);
  }

  close(value): void {
    this.dialogRef.close(value);
  }

  sendFeedback(): void {
    const userFeedback: UserFeedback = {
      feedback: this.feedbackForm.value.feedbackText,
      feedbackType: this.feedbackForm.value.feedbackType,
    };
    this.close(userFeedback);
  }
  getInputHint(inputLength, validLength): string {
    return inputLength?.length + '/' + validLength;
  }
}
